import { Box } from "@mui/material";
import { settings } from "app";
import {
  Datagrid,
  FunctionField,
  NumberField,
  ReferenceField,
  SelectField,
  TextField,
  useRecordContext,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { NationalityType } from "utils/choices";
import NestedItems from "./NestedItems";
import RowActions from "./RowActions";
import { useCollectionActions } from "./CollectionContext";
import CreditFields from "../forms/CreditFields";
import ScheduleFields from "../forms/ScheduleFields";

const FacultativeExpand = () => {
  const row = useRecordContext();
  const { items, saving, updateNestedAt } = useCollectionActions();

  if (!row) return null;

  const item = items[row.rowIndex];

  return (
    <Box sx={{ p: 1 }}>
      <NestedItems
        title="Кредити"
        singular="кредити"
        rowPrefix={`facultativeDisciplines#${row.rowIndex}.credits`}
        items={item?.credits}
        FormFields={CreditFields}
        saving={saving}
        onSave={next => updateNestedAt(row.rowIndex, "credits", next)}
      >
        <SelectField
          source="nationality"
          choices={NationalityType}
          label="Националност"
          sortable={false}
          emptyText="-"
        />
        <ReferenceField
          source="instructionLanguageId"
          reference={administrationRequests.getInstructionLanguagesSelect()}
          label="Език на преподаване"
          link={false}
          sortable={false}
          emptyText="-"
        >
          <TextField
            source="name"
            emptyText="-"
          />
        </ReferenceField>
        <NumberField
          source="credits"
          label="Кредити"
          sortable={false}
          textAlign="left"
          emptyText="-"
        />
      </NestedItems>

      <NestedItems
        title="Разписание"
        singular="разписание"
        rowPrefix={`facultativeDisciplines#${row.rowIndex}.schedules`}
        items={item?.schedules}
        FormFields={ScheduleFields}
        saving={saving}
        onSave={next => updateNestedAt(row.rowIndex, "schedules", next)}
      >
        <NumberField
          source="semester"
          label="Семестър"
          sortable={false}
          textAlign="left"
          emptyText="-"
        />
        <NumberField
          source="lecturesPerSemester"
          label="Лекции / семестър"
          sortable={false}
          textAlign="left"
          emptyText="-"
        />
        <NumberField
          source="seminarExercisesPerSemester"
          label="СУ / семестър"
          sortable={false}
          textAlign="left"
          emptyText="-"
        />
        <NumberField
          source="laboratoryExercisesPerSemester"
          label="ЛУ / семестър"
          sortable={false}
          textAlign="left"
          emptyText="-"
        />
        <NumberField
          source="practicalExercisesPerSemester"
          label="ПУ / семестър"
          sortable={false}
          textAlign="left"
          emptyText="-"
        />
      </NestedItems>
    </Box>
  );
};

const FacultativeDisciplinesGrid = ({ collection }) => (
  <Datagrid
    bulkActionButtons={false}
    rowClick={false}
    expandSingle
    expand={<FacultativeExpand />}
    sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }]}
  >
    <NumberField
      source="order"
      label="Ред"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <ReferenceField
      source="disciplineId"
      reference={administrationRequests.getDisciplinesSelect()}
      label="Дисциплина"
      link={false}
      sortable={false}
      emptyText="-"
    >
      <TextField
        source="name"
        emptyText="-"
      />
    </ReferenceField>
    <NumberField
      source="lecturesAuditoriumOccupancy"
      label="Лекции (ч.)"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="seminarExercisesAuditoriumOccupancy"
      label="СУ (ч.)"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="laboratoryExercisesAuditoriumOccupancy"
      label="ЛУ (ч.)"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="practicalExercisesAuditoriumOccupancy"
      label="ПУ (ч.)"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <NumberField
      source="extracurricularActivities"
      label="Извънаудиторна"
      sortable={false}
      textAlign="left"
      emptyText="-"
    />
    <FunctionField
      label=""
      sortable={false}
      render={() => <RowActions collection={collection} />}
    />
  </Datagrid>
);

export default FacultativeDisciplinesGrid;
